import GroupAdminPage from './GroupAdminPage';
export default GroupAdminPage;
